import { SortModel, SortDirection } from '@instinet-analytics/core-lib';
import { OpenSubmissionsColumn } from '../../grid/OpenSubmissionsColumn';
import { ConfigStateWithGridSupport } from 'widgets/store/grid/reducer';
import { WidgetConfigWithHideableToolbar } from 'widgets/WidgetToolbarShowHidePanel/WidgetConfigWithHideableToolbar';

export type OpenSubmissionsSort = SortModel<OpenSubmissionsColumn>;

export interface OpenSubmissionsConfiguration
    extends ConfigStateWithGridSupport<OpenSubmissionsColumn>,
        WidgetConfigWithHideableToolbar {
    hideDoughnut?: boolean;
    hideGrid?: boolean;
}

export const initialOpenSubmissionsConfiguration: OpenSubmissionsConfiguration =
    {
        sort: [{ colId: 'updateTimeEpoch', sort: SortDirection.DESCENDING }],
        columnWidths: {},
        visibleColumns: [],
        hideToolbar: true,
    };
